export default "__VITE_ASSET__BYJq7krz__"